import { ButtonFilled } from '@snack-uikit/button';
import { HERO_BUTTON_META } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
export function HeroEventButton(_ref) {
  var _meta$disabled, _meta$label, _ref2;
  var href = _ref.href,
    label = _ref.label,
    disabled = _ref.disabled,
    icon = _ref.icon,
    onClick = _ref.onClick,
    type = _ref.type,
    layoutType = _ref.layoutType;
  var meta = type ? HERO_BUTTON_META[type] : undefined;
  var Icon = meta === null || meta === void 0 ? void 0 : meta.icon;
  return /*#__PURE__*/_jsx(ButtonFilled, {
    size: "l",
    onClick: onClick,
    href: href,
    target: "_blank",
    disabled: (_meta$disabled = meta === null || meta === void 0 ? void 0 : meta.disabled) !== null && _meta$disabled !== void 0 ? _meta$disabled : disabled,
    label: (_meta$label = meta === null || meta === void 0 ? void 0 : meta.label) !== null && _meta$label !== void 0 ? _meta$label : label,
    icon: (_ref2 = Icon && /*#__PURE__*/_jsx(Icon, {})) !== null && _ref2 !== void 0 ? _ref2 : icon,
    fullWidth: ['mobile', 'tablet'].includes(layoutType)
  });
}